
import React from 'react';
import { Grid, Typography, withStyles } from '@material-ui/core';
import SearchForm from './SearchForm';
import { useSelector, useDispatch } from "react-redux";
import Results from './results/Results';
import styles from './styles';
import { setAirline } from "../../store/paxSearch";

function PaxSearch(props) {
  const dispatch = useDispatch()
  const { classes, isMobile, airline } = props;
  dispatch(setAirline(airline))
  const searchResults = useSelector(state => state.entities.paxSearch.searchResults)
  const loading = useSelector(state => state.entities.paxSearch.loading)

  return (
    <Grid container>
      <Grid item xs={12} className={classes.searchFormMargin}>
        <SearchForm loading={loading} isMobile={isMobile} />
      </Grid>
      <Grid item xs={12}>
        {!!searchResults.length ? <Results results={searchResults} isMobile={isMobile} airline={airline} /> : <Typography variant='h3'>No results</Typography>}
      </Grid>
    </Grid>
  );
}

export default withStyles(styles)(PaxSearch)